<template>
    <Modal v-model="visible"
           :mask-closable="false"
           footer-hide
           title="Note">
        <p class="note-subtitle"
           v-if="subtitle">{{subtitle}}</p>
        <div class="note-form">
            <Input v-model="text"
                   type="textarea"
                   :autosize="{minRows: 2, maxRows: 8}"
                   :maxlength="5000"
                   placeholder="Make a note"
                   @on-keydown="onKeydown"/>
            <div class="note-buttons">
                <Button type="primary"
                        :loading="saving"
                        :disabled="!changed"
                        @click="save(text)">Save</Button>
                <Poptip v-if="saved"
                        confirm
                        transfer
                        placement="bottom-end"
                        title="Delete this note?"
                        @on-ok="save('')">
                    <Button type="error"
                            ghost
                            :disabled="saving">Delete</Button>
                </Poptip>
            </div>
        </div>
    </Modal>
</template>

<script>
    // Заметка по машине прямо из списка: в кабинете клиента — его личная customer_note,
    // у сотрудников — внутренняя note. Пустое значение удаляет заметку
    export default {
        props: {
            asCustomer: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                visible: false,
                inventory: null,
                text: '',
                saving: false,
            }
        },

        computed: {
            field() {
                return this.asCustomer ? 'customer_note' : 'note'
            },

            saved() {
                return this.inventory ? (this.inventory[this.field] || '') : ''
            },

            changed() {
                return this.text.trim() !== this.saved
            },

            subtitle() {
                if (!this.inventory) return '';
                const {year, make, model, vin} = this.inventory;
                const vehicle = [year && year.isValid() ? year.format('YYYY') : null, make, model]
                    .filter(item => !!item)
                    .join(' ');
                return [vehicle, vin]
                    .filter(item => !!item)
                    .join(' · ')
            },
        },

        methods: {
            open(object = null) {
                this.inventory = object && object.inventory ? object.inventory : null;
                this.text = this.saved;
                this.visible = true
            },

            async save(value) {
                if (!this.inventory || this.saving) return;
                this.saving = true;
                try {
                    const note = this.asCustomer
                        ? await this.inventory.setCustomerNote(value.trim())
                        : await this.inventory.setNote(value.trim());
                    this.inventory[this.field] = note;
                    this.visible = false;
                    this.$emit('on-saved', this.inventory, note)
                } catch (err) {
                    this.$Message.error('Failed to save the note');
                    console.log(err)
                } finally {
                    this.saving = false
                }
            },

            // Ctrl/Cmd+Enter сохраняет, обычный Enter переносит строку
            onKeydown(event) {
                if (event.key === 'Enter' && (event.ctrlKey || event.metaKey) && this.changed) {
                    event.preventDefault();
                    this.save(this.text)
                }
            },
        }
    }
</script>

<style scoped>
    .note-subtitle {
        margin-bottom: 8px;
        color: #808695;
    }

    .note-form {
        display: flex;
        align-items: flex-end;
    }

    .note-form .ivu-input-wrapper {
        margin-right: 8px;
    }

    .note-buttons {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .note-buttons .ivu-btn {
        width: 100%;
    }
</style>
